/**
 * Shared accessor for the active data type (age assurance vs digital IDs).
 *
 * The selection lives in the DOM: `#filter-section[data-data-type]` is the
 * authoritative value and `#data-type-toggle[data-value]` mirrors it. Both are
 * kept in sync by setDataType() in the globe entry. This is the single place
 * that lookup is implemented so the various call sites cannot drift in which
 * attribute they read or in their fallback.
 */
export function getDataType(): string {
  const filterSection = document.getElementById('filter-section')
  const dataTypeToggle = document.getElementById('data-type-toggle')
  return (
    (filterSection && filterSection.getAttribute('data-data-type')) ||
    (dataTypeToggle && dataTypeToggle.getAttribute('data-value')) ||
    'age_assurance'
  )
}
